import CriteriaCondition from '@/components/query/spec/criteria-condition';

export default {
    props: {
        /**
         * @type {NormalizedCondition}
         */
        condition: Object,
        index: Number,
        fieldProvider: Object,
        definition: Object,
        contentClass: {
            type: String,
            default: 'dropdown-content dropdown-content-padded',
        },
        menuContentClass: {
            type: String,
            default: 'dropdown-content',
        },
        groups: Object,
    },
    computed: {
        field() {
            // TODO use definition instead of field provider when present
            // this means the field was added by search instead of loaded from the criteria
            return this.getField();
        },
        hasAutoCompletion() {
            return this.field.autoComplete !== null;
        },
    },
    data() {
        return {
            /**
             * Copy criteria to allow for local editing without
             * interfering with parent scope
             * @type {CriteriaCondition}
             */
            filter: new CriteriaCondition(this.condition),
        };
    },
    methods: {
        getField() {
            return this.fieldProvider.resolveFieldFromCondition(this.condition);
        },
        /**
         * Applies the filter by passing the condition upwards
         */
        applyFilter() {
            throw new Error('not implemented');
        },
        /**
         * Cancels the edit but does not reset the UI.
         * Triggers a dispatch up the ancestry chain.
         */
        cancelFilter() {
            this.$emit('cancel-filter', this.index);
        },
    },
    mounted() {
        if (this.condition && this.$el.scrollIntoView) {
            // if we have a newly added filter scroll it into view
            this.$el.scrollIntoView(false);
        }
    },
};
